import { useAccount } from 'wagmi'
import { useReadPepperContract } from './useReadPepperContract'
import { Hex } from 'viem'

export function usePepperBalance() {
	const { address } = useAccount()

	return useReadPepperContract({
		functionName: 'balanceOf',
		args: [address as Hex],
		query: {
			enabled: !!address
		}
	})
}
